import { z } from 'zod';

// ═══════════════════════════════════════════════════════════════
// KYC - EXTRACCIÓN DE DOCUMENTOS
// Schemas y tipos para la respuesta de extracción de documentos
// ═══════════════════════════════════════════════════════════════

/**
 * Datos personales extraídos del documento
 */
export const extractedPersonalDataSchema = z.object({
  firstName: z.string(),
  secondName: z.string(),
  surname: z.string(),
  motherSurname: z.string(),
  fullName: z.string(),
  sex: z.string(),
  dateOfBirth: z.string(),
  face: z.string(),
  placeOfBirth: z.string(),
  nationality: z.string(),
  maritalStatus: z.string(),
  extra: z.object({
    ocr: z.string(),
    registerYear: z.string(),
    rfc: z.string(),
  }),
});

/**
 * Dirección extraída del documento
 */
export const extractedAddressDataSchema = z.object({
  fullAddress: z.string(),
  postalCode: z.string(),
  extra: z.object({
    street: z.string(),
    externalNumber: z.string(),
    internalNumber: z.string(),
    neighborhood: z.string(),
    city: z.string(),
    state: z.string(),
  }),
});

/**
 * Datos del documento (INE)
 */
export const extractedDocumentDataSchema = z.object({
  type: z.string(),
  side: z.string(),
  country: z.object({
    name: z.string(),
    isoAlpha3Code: z.string(),
    isoAlpha2Code: z.string(),
    icaoCode: z.string(),
  }),
  number: z.string(),
  personalIdNumber: z.string(),
  additionalNumber: z.string(),
  dateOfIssue: z.string(),
  expiration: z.object({
    date: z.string(),
    isPermanent: z.boolean(),
  }),
  issuingAuthority: z.string(),
  extra: z.record(z.unknown()),
});

/**
 * Respuesta completa de extracción de documento
 */
export const documentExtractionResponseSchema = z.object({
  eventId: z.string(),
  requestId: z.string(),
  status: z.string(),
  processingTime: z.number(),
  state: z.object({
    message: z.string(),
    documentCompleteSides: z.boolean(),
  }),
  content: z.object({
    data: z.object({
      personal: extractedPersonalDataSchema,
      address: extractedAddressDataSchema,
      document: extractedDocumentDataSchema,
    }),
  }),
});

/**
 * Tipos inferidos
 */
export type ExtractedPersonalData = z.infer<typeof extractedPersonalDataSchema>;
export type ExtractedAddressData = z.infer<typeof extractedAddressDataSchema>;
export type ExtractedDocumentData = z.infer<typeof extractedDocumentDataSchema>;
export type DocumentExtractionResponse = z.infer<typeof documentExtractionResponseSchema>;
